import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import LeadForm from './lead/leadForm';
import CallbackForm from './callback/callbackForm';
import Popup from '../../Shared/Popup/PopUp';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import {
  setInitialContent,
  initRecaptchaToken,
  checkIsServiceCenterActive,
  setShowPopup,
  createIvrCallback,
  createLead,
  setNameLead,
  setPhoneLead,
  setIsValidLead,
  setIsSubmitLead,
  setPhoneCallbackIvr,
  setIsValidCallbackIvr,
  setIsSubmitCallbackIvr,
  resetLeadBlock,
  setAgreementsCheckBox,
} from './leadBlockSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

const Lead = (props) => {
  useEffect(() => {
    props.actions.initRecaptchaToken();
    props.actions.setInitialContent(props.iContent);
    props.actions.checkIsServiceCenterActive({blockId: props.iContent.contentLink.id});
    return () => {
      props.actions.resetLeadBlock();
    };
  }, []);

  useEffect(() => {
    if (props.lead?.isServiceCenterActive == false) {
      props.actions.setAgreementsCheckBox(props.iContent.leadAgreementsCheckBox.value);
    }
  }, [props.lead?.isServiceCenterActive]);

  function handlePopupClose() {
    props.actions.setShowPopup(false);
  }

  let currentView;
  if (props.lead?.isServiceCenterActive == true) {
    currentView = <CallbackForm data={props.lead} actions={props.actions} />;
  } else if (props.lead?.isServiceCenterActive == false) {
    const leadAgreementsData = {
      leadAgreementsCheckBox: props.iContent.leadAgreementsCheckBox.value,
      leadsubject: props.iContent.leadsubject.value,
      defaulText: Config.potentialCustomerDefaulText,
      tooltipText: Config.potentialCustomerTooltipText,
      bottomText: Config.potentialCustomerBottomText,
      textButton: Config.potentialCustomerTextButton,
      mobileBg: props.iContent.backgroundColorLeadMobile.value,
      desktopBg: props.iContent.backgroundColorLeadDesktop.value,
      btnColorMobile: props.iContent.btnColorLeadMobile.value,
      btnColorDesktop: props.iContent.btnColorLeadDesktop.value,
    };

    currentView = <LeadForm data={props.lead} actions={props.actions} leadAgreementsData={leadAgreementsData} />;
  }

  if (props.lead?.contentData?.appearanceMode == 'POPUP') {
    currentView = (
      <Popup showPopUp={props.lead?.showPopup} onClose={handlePopupClose}>
        {currentView}
      </Popup>
    );
  }

  return <>{currentView}</>;
};

const mapStateToProps = (state) => {
  return {
    lead: state.leadBlock,
  };
};

const actionCreators = {
  setInitialContent,
  initRecaptchaToken,
  showAppLoader,
  hideAppLoader,
  checkIsServiceCenterActive,
  setShowPopup,
  createIvrCallback,
  createLead,
  setNameLead,
  setPhoneLead,
  setIsValidLead,
  setIsSubmitLead,
  setPhoneCallbackIvr,
  setIsValidCallbackIvr,
  setIsSubmitCallbackIvr,
  resetLeadBlock,
  setAgreementsCheckBox,
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actionCreators, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lead);
